'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row\n  align-items: center;\n  color: ', ';\n  font-weight: bold;\n  font-size: ', ';\n  margin: ', ' ', ';\n'], ['\n  display: flex;\n  flex-direction: row\n  align-items: center;\n  color: ', ';\n  font-weight: bold;\n  font-size: ', ';\n  margin: ', ' ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _polished = require('polished');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Wrapper = _styledComponents2.default.label(_templateObject, function (_ref) {
  var theme = _ref.theme;
  return theme.form.labelColor;
}, (0, _polished.rem)(12), (0, _polished.rem)(10), (0, _polished.rem)(5));

var Label = function Label(props, context) {
  var children = props.children,
      className = props.className,
      other = _objectWithoutProperties(props, ['children', 'className']);

  return _react2.default.createElement(Wrapper, _extends({
    htmlFor: props.htmlFor || context.id,
    className: className
  }, other), children);
};

Label.propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.node,
  htmlFor: _propTypes2.default.string
};
Label.defaultProps = {
  className: '',
  children: null,
  htmlFor: null
};
Label.contextTypes = {
  id: _propTypes2.default.string
};
exports.default = Label;
Label.__docgenInfo = [{
  'description': '',
  'displayName': 'Label',
  'methods': [],
  'props': {
    'className': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      }
    },
    'children': {
      'type': {
        'name': 'node'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'null',
        'computed': false
      }
    },
    'htmlFor': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'null',
        'computed': false
      }
    }
  },
  'context': {
    'id': {
      'type': {
        'name': 'string'
      },
      'required': false
    }
  }
}];

if (typeof STORYBOOK_REACT_CLASSES !== 'undefined') {
  STORYBOOK_REACT_CLASSES['src/Label/Label.js'] = {
    name: 'Label',
    docgenInfo: Label.__docgenInfo,
    path: 'src/Label/Label.js'
  };
}